// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SOItemAttributes_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /so/item_attributes/remover
 *
 * Removes a service-order item attribute by ID.
 */
import { registerContract } from './validate'

export interface SOItemAttributes_RemoverInput {
id: number
}

registerContract('SOItemAttributes_RemoverInput', {
  id: { type: 'number',  required: true },
})
